import { Center } from '@euler/components/Center';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { Text, TouchableOpacity } from 'react-native';
import { useTheme } from 'styled-components';

export const AddVehicleInfoHeaderItem = memo(
  ({ onPress }: { onPress?: () => void }) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    return (
      <Center
        style={{
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <TouchableOpacity
          onPress={onPress}
          css={`
            justify-content: center;
            align-items: center;
            padding: 0 ${rpx(16)}px;
            top: ${rpx(3)}px;
          `}
        >
          <Text
            css={`
              color: ${theme.link};
              font-family: ${FontFamily.NotoSans.Regular};
              font-size: ${rpx(14)}px;
              line-height: ${rpx(16)}px;
            `}
          >
            添加
          </Text>
        </TouchableOpacity>
      </Center>
    );
  },
);
